import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63c21362"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "room-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "help"
}
const _hoisted_3 = { class: "main" }
const _hoisted_4 = {
  key: 2,
  class: "compartments"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = {
  key: 4,
  class: "compartments"
}
const _hoisted_7 = { class: "box-error" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = {
  key: 6,
  class: "message-preview-position"
}
const _hoisted_10 = {
  key: 7,
  class: "chat"
}

import { watch, computed, onBeforeMount, onMounted, ref } from 'vue'
import { clamp, useDraggable, useElementBounding, useWindowSize } from '@vueuse/core'
/**
 * Import Components
 */

import BrowserSupportPopup from '@/components/checkup/BrowserSupportPopup.vue'
import Chatbox from '@/components/chatbox/Chatbox.vue'
import ChangeVideoEnginePopup from '@/components/room/ChangeVideoEnginePopup.vue'
import CompartmentGrid from '@/components/room/CompartmentGrid.vue'
import ConfirmProblemCancelPopup from '@/components/room/ConfirmProblemCancelPopup.vue'
import ProblemCancelPopup from '@/components/room/ProblemCancelPopup.vue'
import ProblemCancelLeavePopup from '@/components/room/ProblemCancelLeavePopup.vue'
import DocViewer from '@/components/document/DocViewer.vue'
import FeedbackHelpRequest from '@/components/room/FeedbackHelpRequest.vue'
import NavBar from '@/components/room/RoomNavbar.vue'
import ReportProblemPopup from '@/components/room/ReportProblemPopup.vue'
import RoomControl, { IChangeSetting } from '@/components/room/RoomControl.vue'
import MessagePreview from '../components/chatbox/MessagePreview.vue'
import NotifyVideoEngineChangePopup from '@/components/room/NotifyVideoEngineChangePopup.vue'
import Sticker from '@/components/sticker/Sticker.vue'
import Whiteboard from '@/components/whiteboard/Whiteboard.vue'
import Engder from '@/components/game/Engder.vue'
import CoachAbsentPopup from '@/components/room/CoachAbsentPopup.vue'
import CoachLatePopup from '@/components/room/CoachLatePopup.vue'
import WherebyNavbar from '@/components/room/WherebyNavbar.vue'
import ScreenTrack from '@/components/room/ScreenTrack.vue'
import MultipleSessionsDetectedPopup from '@/components/room/MultipleSessionsDetectedPopup.vue'
import HelpRequestPopup from '@/components/room/HelpRequestPopup.vue'
import CoachMessagePopup from '@/components/room/CoachMessagePopup.vue'
import HelpCollapse from '../components/help-collapse/HelpCollapse.vue'
import PdfViewer from '@/components/document/PdfViewer.vue'

/**
 * Composables
 */
import {
  engineAfter,
  roomConnectErrorMessage,
  roomConnectState,
} from '@/composables/room/useRoomState'
import { screenTrack, multipleSessions } from '@/composables/twilio/useTwilioState'
import {
  // State
  screenShareEnable,
  whiteboardEnable,
  stickerEnable,
  chatEnable,
  documentEnable,
  gameEnable,
  helpEnable,
  currentTab,
  isOpenDeviceSetting,
  isOpenReportProblem,
  isOpenChangeVideoEngine,
  haveMainCompartment,
  mainTabs,
  screenShareShow,

  // Methods
  changeCurrentTab,
  changeToEngine,
} from '@/composables/room/useRoomLayout'
import useRoomNotify from '@/composables/room/useRoomNotify'
import { ROOM_SPACE_URL } from '@/composables/api'
/**
 * Interface
 */
import {
  EngineChangeSocketEmit,
  IWhiteboardSocketState,
  IRequestClassCancelSocket,
  IRoomLayoutProps,
} from '@/types/interfaces/room.interface'
import { Engine, VideoRoomConnectionState } from '@/types/enums/room.enum'
import { IPreviewMessage } from '@/types/interfaces/common.interface'
import { findParticipantInfoByEmail } from '@/helpers/participant.helper'
import useSoundNotify from '@/composables/useSoundNotify'
import { useDeviceStore, useRoomStore } from '@/stores'

import {
  HelpAction,
  HelpResolved,
  HelpRole,
  SolveAction,
  SubmitType,
} from '../types/enums/help.enum'
import useFirestore, { ISendMessage } from '../composables/useFirestore'
import useSpaceApi from '@/composables/api/useSpaceApi'
import useAuth from '@/composables/api/useAuth'
import {
  getHelpClickState,
  getOpenHelp,
  IHelpStoreState,
  setHelpClickState,
  setOpenHelp,
} from '@/services/help-state'
import { checkTimeLimitToShowFeedback } from '@/helpers/help-request.helper'
import { deviceMapForReport } from '@/helpers/detect-device'
import useSocketEvent, { isCoachAttend, roomSocketState } from '@/composables/room/useSocketEvent'
import { SocketHelpEmit } from '@/composables/room/useHelpSystem'
import useGChatLog from '@/composables/api/useGChatLog'
import { messageChatToCoach, messageChatToStudent } from '@/data/mock-help-menu'
import { detectSpaceRoomVersion } from '@/helpers/layout.helper'
import DocumentViewer from '@/components/document/DocumentViewer.vue'

interface RoomLayoutEmits {
  (e: 'toggle-camera', value: boolean): void
  (e: 'toggle-microphone', value: boolean): void
  (e: 'toggle-sticker', value: boolean): void
  (e: 'toggle-chat', value: boolean): void
  (e: 'toggle-document', value: boolean): void
  (e: 'toggle-game', value: boolean): void
  (e: 'toggle-original-material', value: boolean): void
  (e: 'toggle-screen-share', value: boolean): void
  (e: 'toggle-whiteboard', value: boolean): void
  (e: 'disconnect'): void
  (e: 'confirm-welcome'): void
  (e: 'change-cam', value: string): void
  (e: 'change-mic', value: string): void
  (e: 'change-audio', value: string): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RoomLayout',
  props: {
    isHiddenNavbar: { type: Boolean },
    nCompartments: {},
    nParticipants: {},
    isFocused: { type: Boolean },
    roomInfo: {},
    localParticipant: {},
    participantsInfo: {},
    isLoading: { type: Boolean },
    isCoachRole: { type: Boolean },
    isStudentRole: { type: Boolean },
    isWhereby: { type: Boolean },
    mediaStream: {},
    isStartShareScreenWithVideoElement: { type: Boolean },
    engine: {},
    isAutoCloseWelcome: { type: Boolean },
    canMoveRoomByCoach: { type: Boolean },
    isTestRoom: { type: Boolean }
  },
  emits: ["toggle-camera", "toggle-microphone", "toggle-sticker", "toggle-chat", "toggle-document", "toggle-game", "toggle-original-material", "toggle-screen-share", "toggle-whiteboard", "disconnect", "confirm-welcome", "change-cam", "change-mic", "change-audio"],
  setup(__props: any, { emit: __emit }) {

const { sendMessage } = useFirestore()
const { getAccessInfo } = useAuth()
const { toggleEngine, saveLogsHelpRequest, saveLogsHelpResolve, submitProblemCancel } =
  useSpaceApi()

const props = __props

const chatNotifyCount = ref<number>(0)
const newMessage = ref<IPreviewMessage | undefined>(undefined)
const { socket, sendHelpRequest } = useSocketEvent()
const soundNotify = useSoundNotify()
const device = useDeviceStore()
const popoutRef = ref<HTMLElement | null>(null)
const { width: popoutWidth, height: popoutHeight } = useElementBounding(popoutRef)
const { width: windowWidth, height: windowHeight } = useWindowSize()

const { x, y } = useDraggable(popoutRef, {
  initialValue: { x: 30, y: 87 },
})

const roomNotify = useRoomNotify()
const roomStore = useRoomStore()
const { sendSOSForChangeRoom } = useGChatLog()
const emit = __emit

const openBy = ref<string>('')

const isHelpRequestLoading = ref<boolean>(false)
const helpActionType = ref<HelpAction | undefined>(undefined)
const helpSolvedBy = ref<SolveAction | undefined>(undefined)
const coachMessage = ref<string | undefined>(undefined)
const coachSolution = ref<SolveAction | undefined>(undefined)
const mainActionType = ref<HelpAction | undefined>(undefined)
const sendBy = ref<string>()

const originalMaterialEnable = ref<boolean>(false)
const canShowFeedback = ref<boolean>(false)
const showProblemCancelDetail = ref<boolean>(false)
const showConfirmProblemCancel = ref<boolean>(false)
const clickedHelpActions = ref<IHelpStoreState[]>([])
const showStudentMessageCancelClass = ref<boolean>(false)
const participantRequestCancelName = ref<string>('')

// const
const HELP_REQUEST_EVENT = [SolveAction.SHARE_SCREEN, SolveAction.MOVE_ROOM]

/**
 * Computed
 */
const restrictedX = computed(() => clamp(30, x.value, windowWidth.value - 30 - popoutWidth.value))
const restrictedY = computed(() =>
  clamp(87, y.value, windowHeight.value - 100 - popoutHeight.value),
)

const nParticipantsInRoom = computed(() => props.nParticipants ?? props.nCompartments)

const moveTo = computed(() =>
  changeToEngine.value === Engine.WHEREBY
    ? 'whereby'
    : props.roomInfo.isMainEngine
    ? 'secondary'
    : 'main',
)

// when student send requested to coach
const sendMessageToChat = computed(() => {
  if (!helpSolvedBy.value) return ''
  const generateOption = {
    solveBy: helpSolvedBy.value,
    isNeedSupport: false,
    moveTo: moveTo.value,
    userName: props.localParticipant.name,
  }
  if (props.isCoachRole) {
    return messageChatToStudent(generateOption)
  } else {
    return messageChatToCoach(generateOption)
  }
})

const showComponentNightTime = computed(
  () =>
    !props.localParticipant.isCoachRole &&
    roomStore.isNightTime &&
    !!parseInt(props.roomInfo.externalRoomId || '') &&
    props.roomInfo.metaData?.country === 'th',
)

const showFeedbackHelp = computed(() => showComponentNightTime.value && isCoachAttend.value)

const showMainLayout = computed(
  () => (props.isFocused || haveMainCompartment.value) && !props.isLoading,
)

const toggleCamera = () => {
  device.toggleCamera()
  emit('toggle-camera', device.cameraOn)
}

const toggleMicrophone = () => {
  device.toggleMicrophone()
  emit('toggle-microphone', device.microphoneOn)
}

const toggleDocument = () => {
  localStorage.removeItem('persist:viewer')
  documentEnable.value = !documentEnable.value
  changeCurrentTab(documentEnable.value ? 'document' : '')
  emit('toggle-document', documentEnable.value)
}

const toggleScreenShare = () => {
  emit('toggle-screen-share', !screenShareEnable.value)
}

const toggleGame = () => {
  gameEnable.value = !gameEnable.value
  changeCurrentTab(gameEnable.value ? 'game' : '')
  emit('toggle-game', gameEnable.value)
}

const toggleWhiteboard = () => {
  emit('toggle-whiteboard', whiteboardEnable.value)
  if (socket) {
    socket.emit('docWhiteboardControl', {
      roomId: props.roomInfo.id,
      isOpen: !whiteboardEnable.value,
      by: props.localParticipant?.email,
    })
  }
}

const toggleOriginalMaterial = () => {
  originalMaterialEnable.value = !originalMaterialEnable.value
}
/**
 * HELP FUNCTION
 */
const toggleHelp = () => {
  chatEnable.value = false
  helpEnable.value = !helpEnable.value
}
const openPopupHelpRequest = (helpRequest: any) => {
  helpActionType.value = helpRequest.action
  helpSolvedBy.value = helpRequest.solvedBy
}

const clearHelpRequest = () => {
  helpActionType.value = undefined
  helpSolvedBy.value = undefined
}

const sendLogsHelpRequest = async (submitType: SubmitType, helpRole: HelpRole) => {
  const helpRequestPayload = {
    solution: helpSolvedBy.value,
    topic: helpActionType.value,
  }
  if (helpRequestPayload.solution && helpRequestPayload.topic) {
    await saveLogsHelpRequest({
      solution: helpRequestPayload.solution,
      topic: helpRequestPayload.topic,
      submitType,
      role: helpRole,
    })
  }
}

const mockAndSendMessage = async (message?: string) => {
  if (!message) return
  const mockMessage: ISendMessage = {
    roomRefId: props.roomInfo.id,
    message: {
      sendBy: {
        name: 'System Support',
        email: 'engineer@globish.co.th',
        avatar: 'https://d1bnvx5vhcnf8w.cloudfront.net/logo/globish-logo.png',
        role: 'system',
      },
      message,
      fileURL: '',
      type: 'text',
    },
  }
  await sendMessage(mockMessage)
}

const confirmSolution = async () => {
  if (!helpSolvedBy.value) return
  isHelpRequestLoading.value = true
  if (SubmitType.CONFIRM && isCoachAttend.value && helpActionType.value && helpSolvedBy.value) {
    const helpSession = {
      topic: helpActionType.value,
      solveBy: helpSolvedBy.value,
    }
    clickedHelpActions.value = setHelpClickState(helpSession)
  }
  await sendLogsHelpRequest(SubmitType.CONFIRM, HelpRole.SENDER)

  // SEND MESSAGE
  const message = sendMessageToChat.value || ''
  mockAndSendMessage(message)
  // student request to coach
  if (
    props.isStudentRole &&
    helpActionType.value &&
    helpSolvedBy.value &&
    HELP_REQUEST_EVENT.includes(helpSolvedBy.value)
  ) {
    sendHelpRequest({
      solution: helpSolvedBy.value,
      by: props.localParticipant.email,
      message,
      mainAction: helpActionType.value,
    })
  }
  if (props.isCoachRole && helpSolvedBy.value === SolveAction.SHARE_SCREEN) {
    // share screen for coac
    emit('toggle-screen-share', true)
  }

  if (props.isCoachRole && helpSolvedBy.value === SolveAction.MOVE_ROOM) {
    // move room for coach
    await sendSOSForChangeRoom(helpActionType.value)
    await switchEngine()
  }

  if (helpSolvedBy.value === SolveAction.RELOAD_ROOM) {
    // reload room
    window.location.reload()
  } else if (helpSolvedBy.value === SolveAction.MUTE_CAMERA) {
    // Mute camera
    if (device.cameraOn) {
      device.toggleCamera()
      emit('toggle-camera', false)
    }
    // do nothing if camera already mute
  } else if (helpSolvedBy.value === SolveAction.OPEN_ORIGINAL_MATERIAL) {
    if (!documentEnable.value) {
      toggleDocument()
    }
    if (!originalMaterialEnable.value) {
      toggleOriginalMaterial()
    }
  }

  clearHelpRequest()
  isHelpRequestLoading.value = false
}
const switchEngine = async () => {
  const { queryToken } = getAccessInfo()
  try {
    const { status, data } = await toggleEngine([
      mainActionType.value || 'help menu request to move room',
    ])
    if (status === 200) {
      const spaceVersion = detectSpaceRoomVersion(data.currentEngine)
      const dataEmit: EngineChangeSocketEmit = {
        currentEngine: data.currentEngine,
        version: spaceVersion,
      }
      engineAfter.value = data.currentEngine
      socket.emit('engineChanged', dataEmit)
      if (spaceVersion === 'space5') {
        window.location.href = `${ROOM_SPACE_URL}/join?token=${queryToken}&tiger`
      } else {
        window.location.reload()
      }
    }
  } catch (err) {
    console.log(err)
    alert('Cannot toggle engine')
  }
}

const coachConfirmSolution = async () => {
  isHelpRequestLoading.value = true
  if (coachSolution.value && mainActionType.value) {
    await saveLogsHelpRequest({
      solution: coachSolution.value,
      topic: mainActionType.value,
      submitType: SubmitType.CONFIRM,
      role: HelpRole.RECEIVER,
    })
  }

  if (coachSolution.value === SolveAction.MOVE_ROOM) {
    await switchEngine()
  } else if (coachSolution.value === SolveAction.SHARE_SCREEN) {
    emit('toggle-screen-share', true)
  }
  coachMessage.value = undefined
  isHelpRequestLoading.value = false
}

const cancelSolved = async (defaultRole?: HelpRole) => {
  isHelpRequestLoading.value = true
  if (defaultRole) {
    await sendLogsHelpRequest(SubmitType.CANCEL, defaultRole)
  } else {
    await sendLogsHelpRequest(
      SubmitType.CANCEL,
      props.isCoachRole ? HelpRole.RECEIVER : HelpRole.SENDER,
    )
  }
  isHelpRequestLoading.value = false

  helpSolvedBy.value = undefined
  helpActionType.value = undefined
  // coach
  coachSolution.value = undefined
  coachMessage.value = undefined
  mainActionType.value = undefined
  sendBy.value = undefined
}

const changeSetting = (event: IChangeSetting) => {
  switch (event.type) {
    case 'cam':
      device.maskSelectedVideo = event.deviceId
      emit('change-cam', event.deviceId)
      break
    case 'audio':
      device.maskSelectedSpeaker = event.deviceId
      emit('change-audio', event.deviceId)
      break
    case 'mic':
      device.maskSelectedAudio = event.deviceId
      emit('change-mic', event.deviceId)
      break

    default:
      break
  }
}

socket?.on('helpRequest', (data: SocketHelpEmit) => {
  if (props.isCoachRole) {
    const { solution, by, message, mainAction } = data

    if (solution === SolveAction.MOVE_ROOM || solution === SolveAction.SHARE_SCREEN) {
      coachMessage.value = message
      coachSolution.value = solution
      // For coach log
      mainActionType.value = mainAction
      sendBy.value = by
    }
  }
})

socket?.on('whiteboardState', (data: IWhiteboardSocketState) => {
  const { isOpen, by } = data
  openBy.value = by
  /**
   * show room notify when the whiteboard has any action
   */
  const participant = findParticipantInfoByEmail(by, props.participantsInfo)
  if (participant && isOpen !== whiteboardEnable.value) {
    roomNotify.toggleWhiteboard(isOpen, participant)
    whiteboardEnable.value = isOpen
  }
  /**
   * reset whiteboard state if disconnected
   */
  if (!by && !isOpen) {
    whiteboardEnable.value = isOpen
  }
  changeCurrentTab(isOpen ? 'whiteboard' : '')
})

socket?.on('classCancel', (data: IRequestClassCancelSocket) => {
  if (data.sendBy !== props.localParticipant.email) {
    showStudentMessageCancelClass.value = true
    participantRequestCancelName.value = data.participantName
  }
})

const toggleChat = () => {
  helpEnable.value = false
  chatEnable.value = !chatEnable.value
  emit('toggle-chat', chatEnable.value)
}

const toggleSticker = () => {
  stickerEnable.value = !stickerEnable.value
  emit('toggle-sticker', stickerEnable.value)
}

const updateUnreadMessages = (count: number) => {
  chatNotifyCount.value = count
}

const updatePreviewMessages = (messages?: IPreviewMessage) => {
  soundNotify.newMessage()
  newMessage.value = messages
}

/**
 * Computed
 */
const showEngder = computed(
  () => props.roomInfo?.metaData?.engderDeckGroup && props.localParticipant?.capabilities?.engder,
)

const userPermission = computed(() => {
  return {
    ...props.localParticipant.capabilities,
    publishableTracks: {
      ...props.localParticipant.capabilities?.publishableTracks,
      cam: props.localParticipant.capabilities?.publishableTracks.cam,
      mic: props.localParticipant.capabilities?.publishableTracks.mic,
    },
  }
})

const setDefaultState = () => {
  whiteboardEnable.value = false
}

const onSuccessHelp = () => {
  canShowFeedback.value = false
  saveLogsHelpResolve({
    currentEngine: props.roomInfo.currentEngine,
    helpResolve: HelpResolved.YES,
  })
  setOpenHelp()
}

const onOpenConfirmProblemCancel = () => {
  showConfirmProblemCancel.value = true
}

const submitParticipantHaveProblem = () => {
  canShowFeedback.value = false
  showProblemCancelDetail.value = true
  saveLogsHelpResolve({ currentEngine: props.roomInfo.currentEngine, helpResolve: HelpResolved.NO })
  setOpenHelp()
}

const submitCancelClassWithProblem = async (comment?: string) => {
  const classId = parseInt(props.roomInfo.externalRoomId)
  if (!classId) return
  const payload = {
    classId,
    device: deviceMapForReport(),
    helpActions: clickedHelpActions.value.map(({ topic }) => topic) as HelpAction[],
    detail: comment ? comment : undefined,
  }
  const message = `Student ${props.localParticipant.name} requested to cancel this class due to some issues. You can leave the class and mark the attendance report as a problem within class.`
  await mockAndSendMessage(message)
  socket?.emit('requestClassCancel', {
    sendBy: props.localParticipant.email,
    participantName: props.localParticipant.name,
  })
  await submitProblemCancel(payload)
  window.location.href = props.roomInfo.exitPath
}

const openDeviceSetting = () => {
  isOpenDeviceSetting.value = true

  // // Mute camera for engine zoom
  // if (device.cameraOn && props.roomInfo.currentEngine === Engine.ZOOM) {
  //   device.toggleCamera()
  //   emit('toggle-camera', false)
  // }
}

watch(
  () => nParticipantsInRoom.value,
  () => {
    if (nParticipantsInRoom.value > 1) {
      gameEnable.value = false
      changeCurrentTab('')
    }
  },
)

watch(
  () => clickedHelpActions.value.length,
  (value) => {
    if (props.isCoachRole) return
    if (value > 0 && getOpenHelp() !== 'yes') {
      checkTimeLimitToShowFeedback(clickedHelpActions.value, () => {
        if (getOpenHelp() !== 'yes') {
          canShowFeedback.value = true
        }
      })
    }
  },
)
onBeforeMount(() => {
  /**
   * Check if the student has Endger and no one is join room except student
   * then auto open engder game
   */
  if (
    props.roomInfo?.metaData?.engderDeckGroup &&
    props.localParticipant?.capabilities?.engder &&
    nParticipantsInRoom.value === 1
  ) {
    toggleGame()
  }
})

onMounted(() => {
  setDefaultState()
  clickedHelpActions.value = getHelpClickState()
  /**
   * call socket event "checkWhiteboardState" for
   * set whiteboardState value if exist
   */
  socket.emit('checkWhiteboardState', props.roomInfo.id)
})

return (_ctx: any,_cache: any) => {
  const _component_VisualCompartment = _resolveComponent("VisualCompartment")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_DoubleBounceLoader = _resolveComponent("DoubleBounceLoader")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.roomInfo?.currentEngine)
      ? (_openBlock(), _createBlock(BrowserSupportPopup, {
          key: 0,
          engine: _ctx.roomInfo.currentEngine
        }, null, 8, ["engine"]))
      : _createCommentVNode("", true),
    _createVNode(MultipleSessionsDetectedPopup, {
      modelValue: _unref(multipleSessions),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(multipleSessions) ? (multipleSessions).value = $event : null))
    }, null, 8, ["modelValue"]),
    _createVNode(NotifyVideoEngineChangePopup, {
      "is-main-engine": _ctx.roomInfo.isMainEngine
    }, null, 8, ["is-main-engine"]),
    _createVNode(ChangeVideoEnginePopup, {
      modelValue: _unref(isOpenChangeVideoEngine),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isOpenChangeVideoEngine) ? (isOpenChangeVideoEngine).value = $event : null)),
      "move-to": moveTo.value
    }, null, 8, ["modelValue", "move-to"]),
    _createVNode(ReportProblemPopup, {
      modelValue: _unref(isOpenReportProblem),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isOpenReportProblem) ? (isOpenReportProblem).value = $event : null))
    }, null, 8, ["modelValue"]),
    _createVNode(HelpRequestPopup, {
      "is-loading": isHelpRequestLoading.value,
      "help-request-type": helpActionType.value,
      "help-solved-by": helpSolvedBy.value,
      "is-coach-role": _ctx.isCoachRole,
      "is-main-engine": _ctx.roomInfo.isMainEngine,
      onConfirmSolution: confirmSolution,
      onOnClose: _cache[3] || (_cache[3] = ($event: any) => (cancelSolved(_unref(HelpRole).SENDER)))
    }, null, 8, ["is-loading", "help-request-type", "help-solved-by", "is-coach-role", "is-main-engine"]),
    (_ctx.isCoachRole)
      ? (_openBlock(), _createBlock(CoachMessagePopup, {
          key: 1,
          "coach-message": coachMessage.value,
          "is-loading": isHelpRequestLoading.value,
          onOnClose: cancelSolved,
          onConfirmSolution: coachConfirmSolution
        }, null, 8, ["coach-message", "is-loading"]))
      : _createCommentVNode("", true),
    (showComponentNightTime.value && _unref(roomSocketState))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (!_ctx.isCoachRole)
            ? (_openBlock(), _createBlock(CoachAbsentPopup, {
                key: 0,
                "is-attend": _unref(isCoachAttend),
                "start-time": _ctx.roomInfo.startTime,
                "exit-path": _ctx.roomInfo.exitPath
              }, null, 8, ["is-attend", "start-time", "exit-path"]))
            : _createCommentVNode("", true),
          (!_ctx.isCoachRole)
            ? (_openBlock(), _createBlock(CoachLatePopup, {
                key: 1,
                "is-attend": _unref(isCoachAttend),
                "start-time": _ctx.roomInfo.startTime
              }, null, 8, ["is-attend", "start-time"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(Sticker, {
      "is-enable": _unref(stickerEnable),
      onClose: toggleSticker
    }, null, 8, ["is-enable"]),
    (_ctx.isCoachRole)
      ? (_openBlock(), _createBlock(ProblemCancelLeavePopup, {
          key: 3,
          modelValue: showStudentMessageCancelClass.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showStudentMessageCancelClass).value = $event)),
          "student-name": participantRequestCancelName.value,
          "exit-path": _ctx.roomInfo.exitPath
        }, null, 8, ["modelValue", "student-name", "exit-path"]))
      : _createCommentVNode("", true),
    (showFeedbackHelp.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          (canShowFeedback.value)
            ? (_openBlock(), _createBlock(FeedbackHelpRequest, {
                key: 0,
                onNotWorking: submitParticipantHaveProblem,
                onComplete: onSuccessHelp
              }))
            : _createCommentVNode("", true),
          _createVNode(ProblemCancelPopup, {
            modelValue: showProblemCancelDetail.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showProblemCancelDetail).value = $event)),
            onConfirm: onOpenConfirmProblemCancel
          }, null, 8, ["modelValue"]),
          _createVNode(ConfirmProblemCancelPopup, {
            modelValue: showConfirmProblemCancel.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showConfirmProblemCancel).value = $event)),
            onConfirm: submitCancelClassWithProblem
          }, null, 8, ["modelValue"])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["room", {
        '-with-focus': showMainLayout.value,
        '-with-chat': _unref(chatEnable),
        '-with-help': _unref(helpEnable),
        '-hidden-control': _ctx.isWhereby,
      }])
    }, [
      (_unref(helpEnable))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(HelpCollapse, {
              "is-coach-role": _ctx.isCoachRole,
              "is-student-role": _ctx.isStudentRole,
              "current-engine": _ctx.roomInfo.currentEngine,
              "is-main-engine": _ctx.roomInfo.isMainEngine,
              "engine-whereby": _ctx.localParticipant.capabilities.engineWhereby,
              "engine-control": _ctx.localParticipant.capabilities.engineControl,
              country: _ctx.roomInfo?.metaData?.country,
              "help-enable": _unref(helpEnable),
              "can-move-room-by-coach": _ctx.canMoveRoomByCoach,
              onHelpSolveConfirm: openPopupHelpRequest,
              onOnClose: toggleHelp
            }, null, 8, ["is-coach-role", "is-student-role", "current-engine", "is-main-engine", "engine-whereby", "engine-control", "country", "help-enable", "can-move-room-by-coach"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isHiddenNavbar)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isWhereby)
              ? (_openBlock(), _createBlock(WherebyNavbar, {
                  key: 0,
                  "user-permissions": userPermission.value,
                  "document-enable": _unref(documentEnable),
                  "whiteboard-enable": _unref(whiteboardEnable),
                  "chat-enable": _unref(chatEnable),
                  "sticker-enable": _unref(stickerEnable),
                  "game-enable": _unref(gameEnable),
                  "n-compartments": nParticipantsInRoom.value,
                  "exit-path": _ctx.roomInfo.exitPath,
                  "have-track-lesson": _ctx.roomInfo.metaData?.haveTrackLesson,
                  "chat-notify-count": chatNotifyCount.value,
                  "show-help": true,
                  engine: _ctx.engine,
                  "can-change-theme": true,
                  class: "navbar",
                  onToggleDoc: toggleDocument,
                  onToggleWhiteboard: toggleWhiteboard,
                  onToggleChat: toggleChat,
                  onToggleSticker: toggleSticker,
                  onToggleGame: toggleGame,
                  onToggleHelp: toggleHelp
                }, null, 8, ["user-permissions", "document-enable", "whiteboard-enable", "chat-enable", "sticker-enable", "game-enable", "n-compartments", "exit-path", "have-track-lesson", "chat-notify-count", "engine"]))
              : (_openBlock(), _createBlock(NavBar, {
                  key: 1,
                  avatar: _ctx.localParticipant?.avatar,
                  "logo-path": _ctx.roomInfo.logoPath,
                  "user-permissions": _ctx.localParticipant?.capabilities,
                  "is-main-engine": _ctx.roomInfo.isMainEngine,
                  "support-tel": _ctx.roomInfo.supportTel,
                  "support-email": _ctx.roomInfo.supportEmail,
                  "current-engine": _ctx.roomInfo.currentEngine,
                  "exit-path": _ctx.roomInfo.exitPath,
                  "is-recording": _ctx.isCoachRole || !!_ctx.roomInfo.record,
                  "have-track-lesson": _ctx.roomInfo.metaData?.haveTrackLesson,
                  "help-enable": _unref(helpEnable),
                  "is-whereby": _ctx.isWhereby,
                  "show-help": true,
                  "can-change-theme": true,
                  class: "navbar",
                  onToggleHelp: toggleHelp,
                  onOpenDeviceSetting: openDeviceSetting
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "custom-navbar")
                  ]),
                  _: 3
                }, 8, ["avatar", "logo-path", "user-permissions", "is-main-engine", "support-tel", "support-email", "current-engine", "exit-path", "is-recording", "have-track-lesson", "help-enable", "is-whereby"]))
          ], 64))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "main"),
        _withDirectives(_createVNode(_component_Tabs, {
          modelValue: _unref(currentTab),
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(currentTab) ? (currentTab).value = $event : null)),
          tabs: _unref(mainTabs),
          class: "main-tabs"
        }, {
          document: _withCtx(() => [
            _createVNode(_component_VisualCompartment, { class: "h-full" }, {
              default: _withCtx(() => [
                _createVNode(DocumentViewer, {
                  "doc-path": _ctx.roomInfo.docPath,
                  "doc-page-key-store": `p-${_ctx.roomInfo.docId}`
                }, null, 8, ["doc-path", "doc-page-key-store"])
              ]),
              _: 1
            })
          ]),
          screenShare: _withCtx(() => [
            _createVNode(_component_VisualCompartment, { class: "h-full" }, {
              default: _withCtx(() => [
                (_unref(screenTrack))
                  ? (_openBlock(), _createBlock(ScreenTrack, {
                      key: 0,
                      track: _unref(screenTrack)
                    }, null, 8, ["track"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          game: _withCtx(() => [
            _createVNode(_component_VisualCompartment, { class: "h-full" }, {
              default: _withCtx(() => [
                (showEngder.value)
                  ? (_openBlock(), _createBlock(Engder, {
                      key: 0,
                      level: _ctx.roomInfo?.metaData?.engderDeckGroup,
                      email: _ctx.localParticipant.email,
                      type: _ctx.roomInfo?.metaData?.engderType,
                      "class-id": _ctx.roomInfo?.externalRoomId
                    }, null, 8, ["level", "email", "type", "class-id"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "tabs"]), [
          [_vShow, _unref(mainTabs).length]
        ])
      ], 512), [
        [_vShow, showMainLayout.value]
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_VisualCompartment, { class: "compartments -connecting" }, {
              default: _withCtx(() => [
                _createVNode(_component_DoubleBounceLoader, { size: 40 }),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('joining')) + "...", 1),
                  _hoisted_5,
                  _createTextVNode(_toDisplayString(_ctx.$t('connect-video')), 1)
                ]),
                _renderSlot(_ctx.$slots, "loading")
              ]),
              _: 3
            })
          ]))
        : (!_ctx.isLoading && _unref(roomConnectState) !== _unref(VideoRoomConnectionState).ConnectFailed)
          ? (_openBlock(), _createBlock(CompartmentGrid, {
              key: 3,
              "n-compartments": _ctx.nCompartments,
              "is-focused": showMainLayout.value,
              class: "compartments"
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["n-compartments", "is-focused"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_VisualCompartment, { class: "compartments -connecting-fail" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(roomConnectErrorMessage)), 1),
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-reload",
                      onClick: _cache[8] || (_cache[8] = () => _ctx.$router.go(0))
                    }, [
                      _createVNode(_component_SvgIcon, {
                        class: "_pointer-on-hover ml-1 mr-3",
                        icon: "reload",
                        "inherit-fill": true,
                        height: "21"
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('reload-room')), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ])),
      (!_ctx.isWhereby)
        ? (_openBlock(), _createBlock(RoomControl, {
            key: 5,
            "n-compartments": nParticipantsInRoom.value,
            "user-permissions": userPermission.value,
            "is-small": showMainLayout.value || _ctx.engine === _unref(Engine).VICOLLO,
            "camera-enable": _unref(device).cameraOn,
            "microphone-enable": _unref(device).microphoneOn,
            "document-enable": _unref(documentEnable),
            "screen-share-enable": _unref(screenShareEnable),
            "whiteboard-enable": _unref(whiteboardEnable),
            "chat-enable": _unref(chatEnable),
            "sticker-enable": _unref(stickerEnable),
            "game-enable": _unref(gameEnable),
            "screen-share-show": _unref(screenShareShow),
            "chat-notify-count": chatNotifyCount.value,
            engine: _ctx.engine,
            class: "room-control",
            onToggleCam: toggleCamera,
            onToggleMic: toggleMicrophone,
            onToggleDoc: toggleDocument,
            onToggleScreenShare: toggleScreenShare,
            onToggleWhiteboard: toggleWhiteboard,
            onToggleChat: toggleChat,
            onToggleSticker: toggleSticker,
            onToggleGame: toggleGame,
            onSwitchDevice: changeSetting
          }, null, 8, ["n-compartments", "user-permissions", "is-small", "camera-enable", "microphone-enable", "document-enable", "screen-share-enable", "whiteboard-enable", "chat-enable", "sticker-enable", "game-enable", "screen-share-show", "chat-notify-count", "engine"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref_key: "popoutRef",
        ref: popoutRef,
        class: "popout",
        style: _normalizeStyle({
          top: `${restrictedY.value}px`,
          left: `${restrictedX.value}px`,
        })
      }, [
        _renderSlot(_ctx.$slots, "popout")
      ], 4),
      (_ctx.localParticipant?.capabilities?.chat)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(MessagePreview, {
              "new-message": newMessage.value,
              onClick: _cache[9] || (_cache[9] = ($event: any) => (chatEnable.value = true))
            }, null, 8, ["new-message"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.localParticipant?.capabilities?.chat)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(Chatbox, {
              "enable-chat": _unref(chatEnable),
              room: _ctx.roomInfo,
              "local-participant": _ctx.localParticipant,
              onUnreadUpdated: updateUnreadMessages,
              onNewMessages: updatePreviewMessages,
              onClose: _cache[10] || (_cache[10] = ($event: any) => (chatEnable.value = false))
            }, null, 8, ["enable-chat", "room", "local-participant"])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})